import { usePageStore } from '@/store';
import { findModuleStore } from '@/store/helpers';
import { fetchFilterItemOptions } from '@/modules/md-search-bar/api.js';
import * as TYPES from '@/modules/md-search-bar/_store/types';

/**
 * 根据预设条件生成选择选项的 hook
 * 基于 getSelectOptionsWithPresetParams 的逻辑
 * @param {Object} options - 配置选项
 * @param {Object} options.fetcherData - 搜索数据，包含 rawConf
 * @param {Object} options.computedCondition - 计算后的条件对象
 * @param {Object} options.context - Vue 组件上下文，包含 axiosIns 和 $pinia
 * @returns {Promise<void>}
 */
export default function useSelectOption({ fetcherData, computedCondition, context }) {
    if (!fetcherData || !context) {
        console.warn('useSelectOption: fetcherData and context are required');
        return Promise.resolve();
    }

    const { $pinia } = context;
    const { siteId } = usePageStore($pinia);
    const searchStore = findModuleStore.call(context);
    const updateRawConfOptions = searchStore[TYPES.UPDATE_RAWCONF_OPTIONS];
    
    const searchData = fetcherData?.rawConf;


    if (!searchData || !Array.isArray(searchData)) {
        return Promise.resolve();
    }

    // 收集所有需要获取选项的条件
    const optionPromises = [];

    searchData.forEach(config => {
        const { conditions } = config;
        if (!conditions || !Array.isArray(conditions)) {
            return;
        }

        conditions.forEach(o => {
            if (
                o.inputType === 'multiSelect' ||
                o.inputType === 'singleSelect'
            ) {

                if (computedCondition) {
                    const curValue = computedCondition[o.name.toLowerCase()];
                    if (curValue) {
                        const promise = fetchFilterItemOptions.call(context, {
                            siteId,
                            type: o.name
                        }).then(data => {
                            updateRawConfOptions({ name: o.name, options: data || [] });
                        }).catch(error => {
                            console.error(`Failed to fetch options for ${o.name}:`, error);
                            updateRawConfOptions({ name: o.name, options: [] });
                        });
                        optionPromises.push(promise);
                    }
                }
            }
        });
    });

    // 等待所有选项加载完成
    return Promise.all(optionPromises);
}

